import { type PropsWithChildren, useEffect } from 'react';
import { installTableTextSelectionGuard } from './selection';

/** 覆盖后台全部 Ant Table / ProTable，包括弹窗和抽屉中的列表。 */
export default function TableTextSelectionGuard({
  children,
}: PropsWithChildren) {
  useEffect(() => installTableTextSelectionGuard(document), []);
  return children;
}
